import { useCallback, useMemo } from 'react';

import { DevicesList } from './components/DevicesList';
import { DeviceStatus } from './components/DeviceStatus';
import { TextCell } from './components/TextCell';

import type { SystemStatusModel } from '../../model/types/system-status.model';
import type { ColumnDefinition } from '@turnpike/portal-data-grid';

export const useSystemStatusTableLayoutColumns = () => {
	const columns = useMemo((): ColumnDefinition<SystemStatusModel>[] => {
		return [
			{
				key: 'name',
				title: 'Name',
				width: 220,
				draggable: false,
				render: (_value, row) => <TextCell isBold={true} text={row.name} />,
			},
			{
				key: 'country',
				title: 'Country',
				width: 150,

				render: (_value, row) => <TextCell text={row.country} />,
			},
			{
				key: 'city',
				title: 'City',
				width: 150,

				render: (_value, row) => <TextCell isDark={true} text={row.city} />,
			},
			{
				key: 'device-status',
				title: 'device status',
				width: 200,
				align: 'center',
				render: (_value, row) => (
					<DeviceStatus
						onCounter={row.devices.connected}
						offCounter={row.devices.disconnected}
					/>
				),
			},
			{
				key: 'total-devices',
				title: 'total devices',
				width: 200,
				align: 'center',
				sortFn: (a, b) => a.devices.total - b.devices.total,
				render: (_value, row) => <TextCell isDark={true} text={row.devices.total} />,
			},
			{
				key: 'user-status',
				title: 'user status',
				width: 200,
				align: 'center',

				render: (_value, row) => (
					<DeviceStatus onCounter={row.users.online} offCounter={row.users.offline} />
				),
			},
			{
				key: 'total-users',
				title: 'total users',
				width: 200,
				align: 'center',
				sortFn: (a, b) => a.users.total - b.users.total,
				render: (_value, row) => <TextCell isDark={true} text={row.users.total} />,
			},
		];
	}, []);

	const renderDetailsRow = useCallback((row: SystemStatusModel) => {
		return <DevicesList devices={row.devices.devices} />;
	}, []);

	return { columns, renderDetailsRow };
};
